import Settings from 'src/Settings';
import Styles from '../../../Styles';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import AVText from 'src/components/elements/AVText';
import LocationMarker from 'src/components/img/svg/LocationMarker';
import {HomeLocationProps} from 'src/components/elements/descriptor/DescriptorType';
import NotificationUnReadIcon from 'src/components/img/svg/newui/notificationUnReadLogo';
import NotificationIcon from 'src/components/img/svg/newui/notificationLogo';
import Localized from 'src/constants/AppStrings';
import ShopIconPay from 'src/components/img/svg/ShopIconpay';
import GreetingsAndBalanceView from 'src/components/elements/home/GreetingsAndBalanceView';
import {RewardsWrappedComponent} from 'src/components/screens/home/RewardsHoc';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import {View} from 'react-native';
import MilkIcon from 'src/components/img/svg/newui/milk';
import CoolDrinkIcon from 'src/components/img/svg/newui/cooldrink';
import AwarenessIcon from 'src/components/img/svg/newui/awareness';
import FruitIcon from 'src/components/img/svg/newui/fruit';

export function getCampusLocationStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusView: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '80%',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      marginLeft: Styles.Spacing.m3,
      marginRight: Styles.Spacing.m4,
      minHeight: Styles.MinTouchableArea,
      marginBottom: 10,
    },
    linkLocationBtnStyle: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      color: '#066DFF',
      textDecorationLine: 'none',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    linkView: {
      alignSelf: 'flex-start',
      borderBottomColor: '#066DFF',
      borderBottomWidth: 1.5,
    },
    descriptionTextFont: {
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
  };
}

export function getScanProductName(): string {
  return Localized.Labels.scan_product;
}

export function getScanProductBtnStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    applyButtonText: {
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: getLayoutDescriber().bodyFontSize(),
      textAlign: 'right',
      fontWeight: '400',
    },
  };
}

export function backGroundColorHomeScreen(): string {
  return Styles.tabBarBackgroundColor;
}
export function locationHeaderName(): string {
  return Localized.Labels.locations;
}

export function locationListIcon(): JSX.Element {
  return <ShopIconPay size={25} />;
}

export function linkLocationDropDown(props?: HomeLocationProps): JSX.Element {
  return (
    <>
      <View style={homeLocationHeaderStyleDescriptor().locationMainView}>
        <LocationMarker
          size={Styles.Fonts.f3}
          color={Settings.isRefiveAnd365Pay() && Styles.Colors.PayNew.white01}
        />
      </View>
      <AVText
        style={[
          homeLocationHeaderStyleDescriptor().campusNameText,
          homeLocationHeaderStyleDescriptor().locationText365,
        ]}
        numberOfLines={1}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {props.locationNameText}
      </AVText>
      <FontAwesome5Pro
        accessible={true}
        accessibilityLabel={
          'Down arrow icon, Double tap to the Locations Screen'
        }
        aria-label={'Down arrow icon, Double tap to the Locations Screen'}
        name="chevron-down"
        color={Styles.Colors.PayNew.white01}
        size={Styles.Heights.touchTargetHeight0}
        style={[homeLocationHeaderStyleDescriptor().campusArrow]}
        testID="qa_dpd_SelectLocation"
      />
    </>
  );
}

export function greetingBalanceRewardsView(
  shortcutBar: JSX.Element,
  _data?: {
    [index: string]: {[index: string]: number | string};
  },
  location?: string,
  trackerSlot?: JSX.Element,
): JSX.Element {
  return (
    <>
      {shortcutBar}
      {trackerSlot}
      <GreetingsAndBalanceView />
      {location && <RewardsWrappedComponent data={_data} />}
    </>
  );
}
export function readUnreadNotificationIcon(
  props?: HomeLocationProps,
): JSX.Element {
  return (
    <>
      {props.readOrUnreadNotificaton ? (
        <NotificationUnReadIcon
          color={
            Settings.isRefiveAnd365Pay()
              ? Styles.Colors.PayNew.white01
              : '#003349'
          }
          size={Styles.Fonts.f4 + 6}
        />
      ) : (
        <NotificationIcon
          color={
            Settings.isRefiveAnd365Pay()
              ? Styles.Colors.PayNew.white01
              : '#003349'
          }
          size={Styles.Fonts.f3}
        />
      )}
    </>
  );
}

export function homeLocationHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusNameText: {
      marginLeft: Styles.Spacing.m0,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      color: Styles.white,
      fontFamily: Styles.FontFamily.robotoRegular,
      flexShrink: 1,
    },
    campusArrow: {
      marginLeft: Styles.Spacing.m2,
      marginBottom: 4,
    },
    locationMainView: {
      marginBottom: 4,
    },
    locationText365: {
      color: Styles.white,
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: getLayoutDescriber().headerFontSize(),
      fontWeight: '700',
      marginBottom: 4,
    },
  };
}

export function getLocationEmptyIcons() {
  return {
    milk: <MilkIcon fill={getLayoutDescriber().primaryColor()} />,
    coolDrink: <CoolDrinkIcon fill={getLayoutDescriber().primaryColor()} />,
    awareness: <AwarenessIcon fill={getLayoutDescriber().primaryColor()} />,
    fruit: <FruitIcon fill={getLayoutDescriber().primaryColor()} />,
  };
}

export function getTileButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  return null;
}

export function shortCutButtonBorderColor(): string {
  return Styles.Colors.PayNew.brightGray;
}

export default {
  getScanProductName,
  getScanProductBtnStyle,
  getCampusLocationStyles,
  backGroundColorHomeScreen,
  homeLocationHeaderStyleDescriptor,
  linkLocationDropDown,
  locationHeaderName,
  readUnreadNotificationIcon,
  locationListIcon,
  greetingBalanceRewardsView,
  getLocationEmptyIcons,
  getTileButton,
  getTrackerPlacement: () => 'top',
  shortCutButtonBorderColor,
};
